import request from '../network';

export interface PetListParams {
  createEndTime?: string;
  createStartTime?: string;
  medicalHistoryDetails?: number | string;
  mobile?: string;
  pageNum?: number;
  pageSize?: number;
  petNickName?: string;
  petOneId?: string;
  petType?: number | string;
  tagId?: number | string;
  oneId?: string;
  updateEndTime?: string;
  updateStartTime?: string;
  [property: string]: any;
}

export const getPetListApi = (data: PetListParams) => {
  return request({
    url: '/member/royalcanin/admin/petInfo/page',
    method: 'POST',
    data,
  });
};

export const getPetDetailApi = (params: { petOneId?: string }) => {
  return request({
    url: '/member/royalcanin/admin/petInfo/details',
    method: 'GET',
    params,
  });
};
